/**
 * Types for the in-app feedback widget.
 */

/** The three categories offered by the feedback dialog. */
export type FeedbackCategory = 'issue' | 'feature' | 'general';

export const FEEDBACK_CATEGORIES: readonly FeedbackCategory[] = ['issue', 'feature', 'general'];

/** Server-side configuration mirrored by the client for instant validation. */
export interface FeedbackConfig {
  enabled: boolean;
  max_files: number;
  max_file_bytes: number;
  max_summary_length: number;
  max_details_length: number;
  allowed_extensions: string[];
}

export interface FeedbackSubmission {
  category: FeedbackCategory;
  summary: string;
  details: string;
  pageUrl?: string;
  searchQuery?: string;
  uiLanguage?: string;
  /** Optional reply address; the ticket is filed under this contact. */
  email?: string;
  files: File[];
}

export interface FeedbackResponse {
  ticket_number: string | null;
  attachments_uploaded: number;
  attachments_failed: number;
}
